import React, { useEffect } from "react";
import { paramsListName } from "src/api/config";
import { myTasksIncidentsStatusesListName } from "src/api/config/myTasksInc.config";
import { incStatus } from "src/api/config/systemSwitch";
import { useAppDispatch, useAppSelector } from "src/hooks/redux";
import { selectItems } from "src/modules/spItems/selectors";

export const Statuses5WayNotice = ({ typeInc, statuses }: any) => {

    const params: any = useAppSelector((state) => selectItems(state, paramsListName));

    return (
        <div className='flex flex-col w-full gap-[10px] p-[10px]'>
            {typeInc && statuses.map((status: any, index: number) => (
                <React.Fragment key={index}>
                    {((typeInc === 'Несоответствие' && status.ID === incStatus.finish) || (typeInc === 'Инцидент' && status.ID === incStatus.closed)) &&
                        <></>
                        ||
                        <div className='flex flex-row w-full items-center gap-[16px]'>
                            <div className="flex justify-end max-w-[140px] w-full">
                                <div style={{ backgroundColor: status.Color }} className="flex flex-row text-white py-[5px] px-[14px] rounded-md text-sm h-fit">{status.Title}</div>
                            </div>
                            <div className="text-black text-sm">{typeInc === 'Несоответствие' && status.TextN || status.TextInc}</div>
                        </div>
                    }
                </React.Fragment>
            ))}
            <div className="flex flex-col mt-[10px]">
                {typeInc && typeInc === 'Несоответствие' &&
                    <>
                        <p className="text-black text-sm">Y для Несоответствия по Безопасности = {Number(params.find((param: any) => param.Key === "NSafeDate")["Value"].trim())}</p>
                        <p className="text-black text-sm">Y для Несоответствия по Экологии = {Number(params.find((param: any) => param.Key === "NEnvDate")["Value"].trim())}</p>
                        <p className="text-black text-sm">Y для Несоответствия по Качеству = {Number(params.find((param: any) => param.Key === "NQualityDate")["Value"].trim())}</p>
                        <p className="text-black text-sm">Y для Несоответствия по Техобслуживанию = {Number(params.find((param: any) => param.Key === "NMDate")["Value"].trim())}</p>
                    </>
                }
                {typeInc && typeInc === 'Инцидент' &&
                    <>
                        <p className="text-black text-sm">Y для Инцидента по Безопасности = {Number(params.find((param: any) => param.Key === "IncSafeDate")["Value"].trim())}</p>
                        <p className="text-black text-sm">Y для Инцидента по Экологии = {Number(params.find((param: any) => param.Key === "IncEnvDate")["Value"].trim())}</p>
                        <p className="text-black text-sm">Y для Инцидента в Процессе = {Number(params.find((param: any) => param.Key === "IncProcessDate")["Value"].trim())}</p>
                        <p className="text-black text-sm">Y для Инцидента по Качеству = {Number(params.find((param: any) => param.Key === "IncQualityDate")["Value"].trim())}</p>
                        <p className="text-black text-sm">Y для Инцидента по Техобслуживанию = {Number(params.find((param: any) => param.Key === "IncMDate")["Value"].trim())}</p>
                    </>
                }
            </div>
        </div>
    );
}